import { MDSIconKind } from "@/mds/components/icon";
import { MDSComboboxDropdownOption } from "@/mds/components/forms/combobox/combobox.types";
import { ChatModel } from "./chat-model-types";

export const MODEL_OPTIONS: MDSComboboxDropdownOption[] = [
  { id: ChatModel.Auto, label: "Auto", icon: MDSIconKind.Logo },
  // { id: ChatModel.Sonnet45, label: "Sonnet 4.5", icon: MDSIconKind.Anthropic },
  { id: ChatModel.Sonnet, label: "Sonnet 4.6", icon: MDSIconKind.Anthropic },
  // { id: ChatModel.GPT, label: "GPT 5.2", icon: MDSIconKind.OpenAI },
  // { id: ChatModel.GPT53, label: "GPT 5.3", icon: MDSIconKind.OpenAI },
  { id: ChatModel.GPT54, label: "GPT 5.4", icon: MDSIconKind.OpenAI },
  { id: ChatModel.Gemini, label: "Gemini 3", icon: MDSIconKind.GoogleGemini },
  {
    id: ChatModel.Gemini31Pro,
    label: "Gemini 3.1 Pro",
    icon: MDSIconKind.GoogleGemini,
  },
];

export const CHAT_MODEL_LABELS: Record<ChatModel, string> = {
  [ChatModel.Auto]: "Auto",
  [ChatModel.Sonnet45]: "Sonnet 4.5",
  [ChatModel.Sonnet]: "Sonnet 4.6",
  [ChatModel.GPT]: "GPT 5.2",
  [ChatModel.GPT53]: "GPT 5.3",
  [ChatModel.GPT54]: "GPT 5.4",
  [ChatModel.Gemini]: "Gemini 3",
  [ChatModel.Gemini31Pro]: "Gemini 3.1 Pro",
};
